module.exports = __webpack_public_path__ + "static/img/warehouse05.59c4bad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warehouse05.jpg
// module id = zF2L
// module chunks = 0